import name from "./name"

const selectSliceData = state => state[name]

const selectClientConfig = state => selectSliceData(state).clientConfig



export { selectClientConfig }
